import React from 'react';
import Immutable from 'immutable';
import numberWithCommas from '../../utils/numberFormat';
import { SHARE, COMMENT, LIKE } from '../../constants/ModalTypes';

const PostCountBar = ({ profile, post, device, showModal }) => {
  const { permalink, commentable, unlisted, likeCount, commentCount, shareCount } = post;
  const deviceOsName = device.getIn(['os', 'name']);
  const isPC = deviceOsName !== 'Android' && deviceOsName !== 'iOS';
  const isAdult = profile.isAdult;

  return (
    <div className="cmt_util">
      <button type="button" className="btn_count"
        onClick={() => isPC ? alert('포스트 좋아요는 카카오톡 모바일앱에서 가능합니다.') : showModal(LIKE, { post, device })}
      >
        <span className="ico_plus ico_heart">좋아요</span>{(!post.blindType || post.blindType === '') ? numberWithCommas(likeCount) : 0}
      </button>
      {
        commentable &&
          <button type="button" className="btn_count"
            onClick={() => isPC ? alert('댓글 작성은 카카오톡 모바일 앱에서 가능합니다.') : showModal(COMMENT, { post, device })}
          >
            <span className="ico_plus ico_cmt">댓글</span>{(!post.blindType || post.blindType === '') ? numberWithCommas(commentCount) : 0}
          </button>
      }
      {
        !unlisted && !isAdult &&
         <button
           type="button" className="btn_count btn_share btn_share2"
           onClick={() => (!post.blindType || post.blindType === '') ? showModal(SHARE, { post, permalink, device }) : alert('운영정책에 의해 제한된 게시물입니다.')}
         >
           <span className="inner_txt">
             <span className="ico_plus ico_share" />
             공유 {(!post.blindType || post.blindType === '') ? (shareCount > 0 && numberWithCommas(shareCount)) : 0}
             </span>
         </button>
      }
    </div>
  );
}

export default PostCountBar;




// WEBPACK FOOTER //
// ./src/components/PostCountBar/index.js